module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/keys"
// module id = 12
// module chunks = 0